import React, { Component } from 'react'
import { Map, TileLayer, Marker, Popup, LayersControl } from 'react-leaflet'
import L, { latLngBounds } from 'leaflet'
// import MarkerClusterGroup from 'react-leaflet-markercluster'
import 'react-leaflet-markercluster/dist/styles.min.css'
import './destination-map-popup.sass'

export const shopIcon = new L.Icon({
  iconUrl: `${window.staticPath}travel_dist/images/marker.png`,
  iconRetinaUrl: `${window.staticPath}travel_dist/images/marker.png`,
  iconSize: [23, 30],
})

export const hoveredShopIcon = new L.Icon({
  iconUrl: `${window.staticPath}travel_dist/images/marker-violet.png`,
  iconRetinaUrl: `${window.staticPath}travel_dist/images/marker-violet.png`,
  iconSize: [23, 30],
})

export const diveCenterIcon = new L.Icon({
  iconUrl: `${window.staticPath}travel_dist/images/ds-pin.png`,
  iconRetinaUrl: `${window.staticPath}travel_dist/images/ds-pin.png`,
  iconSize: [36, 36],
})

export default class DestinationsMap extends Component {
  render() {
    const bounds = latLngBounds()

    bounds.extend([this.props.shopPin.lat, this.props.shopPin.lng])

    this.props.mapData.forEach((data) => {
      bounds.extend([data.latitude, data.longitude])
    })

    return (
      <Map bounds={bounds} zoom={4} style={{ height: '100%' }} maxZoom={18} scrollWheelZoom={false}>
        <LayersControl position='topright'>
          <LayersControl.BaseLayer name='Satellite' checked>
            <TileLayer
              url='//server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'
            />
          </LayersControl.BaseLayer>
          <LayersControl.BaseLayer name='PADI Travel map'>
            <TileLayer
              url='https://api.mapbox.com/styles/v1/mapbox/light-v9/tiles/256/{z}/{x}/{y}@2x?access_token=pk.eyJ1IjoiZGl2aWFjIiwiYSI6ImNiZjU5MGVlY2VkZmQ4YWFkNGJmMWVjMDVjMDUzNDdlIn0.62dEH0gmRXAGO5e2x1JnRg'
            />
          </LayersControl.BaseLayer>
        </LayersControl>
        <Marker position={[this.props.shopPin.lat, this.props.shopPin.lng]} icon={shopIcon}>
          <Popup className='destination-map-popup'>
            { this.props.shopTitle }
          </Popup>
        </Marker>
        {/* <MarkerClusterGroup> */}
        {
          this.props.mapData.map((pin, index) => {
            return (<Marker key={index} position={[pin.latitude, pin.longitude]} icon={diveCenterIcon}>
              <Popup className='destination-map-popup'>
                { pin.title }
              </Popup>
            </Marker>)
          })
        }
        {/* </MarkerClusterGroup> */}
      </Map>
    )
  }
}
